export * from './keycloakRoleController.service';
import { KeycloakRoleControllerService } from './keycloakRoleController.service';
export * from './userManagementController.service';
import { UserManagementControllerService } from './userManagementController.service';
export const APIS = [KeycloakRoleControllerService, UserManagementControllerService];
